<template>
  <div class="popup">
    <div class="popup-trigger">
      <button type="button" v-on:click="show = true" ref="trigger"><slot name="trigger"></slot></button>
    </div>

    <div
      class="popup-content"
      v-bind:class="{ show: show }"
      v-on:click="show = false"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    this.$root.$on("app-click", (event) => {
      let show = this.show;
      this.show = false;
      let element = event.target;
      do {
        if (element === this.$refs.trigger) {
          this.show = show;
          break;
        }

        element = element.parentElement;
      } while (element);
    });
  },
};
</script>

<style lang="scss" scoped>
.popup-trigger {
  & > button {
    border: none;
    background: transparent;
  }
}

.popup-content {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  //   width: 100%;
  //   height: 100%;
  // width: min-content;
  // -webkit-height: min-content;
  // height: min-content;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  z-index: 10000000;

  &.show {
    display: initial;
  }
}
</style>